import React, { useEffect, useState } from 'react';
import Pagination from '../components/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getNotifications, markNotificationRead, markAllNotificationsRead } from '../services/api';
import './Notifications.css';

const Notifications = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 20;

  const fetchNotifications = async () => {
    try {
      const res = await getNotifications(page, pageSize);
      const data = res.data || {};
      setNotifications(data.items || []);
      setTotal(data.total || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login');
      return;
    }
    if (user) fetchNotifications();
  }, [user, authLoading, navigate, page]);

  const handleRead = async (id) => {
    await markNotificationRead(id);
    fetchNotifications();
  };

  const handleReadAll = async () => {
    await markAllNotificationsRead();
    fetchNotifications();
  };

  if (loading) return <div className="notifications-page"><div className="spinner" /></div>;

  return (
    <div className="notifications-page">
      <div className="notifications-header">
        <h1>Notifications</h1>
        {notifications.some((n) => !n.read) && (
          <button className="btn btn-secondary btn-sm" onClick={handleReadAll}>Mark all read</button>
        )}
      </div>

      {notifications.length === 0 ? (
        <p className="empty-notifications">No notifications yet</p>
      ) : (
        <ul className="notifications-list">
          {notifications.map((n) => (
            <li key={n._id} className={`notification-item ${n.read ? 'read' : 'unread'}`}>
              <div className="notification-content">
                <strong>{n.title}</strong>
                <p>{n.message}</p>
                <span className="notification-time">{new Date(n.createdAt).toLocaleString()}</span>
              </div>
              <div className="notification-actions">
                {n.link && <Link to={n.link} className="btn btn-primary btn-sm">View</Link>}
                {!n.read && (
                  <button className="btn btn-secondary btn-sm" onClick={() => handleRead(n._id)}>Mark read</button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
      <Pagination
        page={page}
        totalPages={Math.max(1, Math.ceil(total / pageSize))}
        total={total}
        pageSize={pageSize}
        onPageChange={setPage}
        label="notifications"
      />
    </div>
  );
};

export default Notifications;
